import { put, call, fork, select, throttle, all, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import * as routes from '../../components/index/routes';
import { reset as resetForm, stopSubmit } from 'redux-form';
import * as appsModule from '../modules/apps.module';
import * as Api from '../../core/api';

export function* fetchApps({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.apps.sort);
  const filter = yield select((state) => state.apps.filter);
  const account = yield select((state) => state.account);

  const { response, error } = yield call(Api.apps.fetchApps, {
    page, itemsPerPage, sort, filter, role: account.role,
  });

  if (response) {
    yield put(appsModule.fetchAppsSuccess({ apps: response, filter }));
  } else {
    yield put(appsModule.fetchAppsFail(error));
  }
}
export function* watchFetchApps() {
  yield takeEvery(appsModule.fetchApps.getType(), fetchApps);
}

export function* fetchAppsNames() {
  const { response, error } = yield call(Api.apps.fetchAppsNames);

  if (response) {
    yield put(appsModule.fetchAppsNamesSuccess(response));
  } else {
    yield put(appsModule.fetchAppsNamesFail(error));
  }
}
export function* watchFetchAppsNames() {
  yield takeEvery(appsModule.fetchAppsNames.getType(), fetchAppsNames);
}

export function* parseAppFromUrl({ payload: url }) {
  const { response, error } = yield call(Api.apps.parseAppFromUrl, url);

  if (response) {
    yield put(appsModule.parseAppFromUrlSuccess(response));
  } else {
    yield put(appsModule.parseAppFromUrlFail(error));
  }
}
export function* watchParseAppFromUrl() {
  yield takeEvery(appsModule.parseAppFromUrl.getType(), parseAppFromUrl);
}

export function* addApp({ payload: app }) {
  const formName = yield select((state) => state.newApp.formName);
  const { response, error } = yield call(Api.apps.addApp, app);

  if (response) {
    yield put(appsModule.addAppSuccess(response));
    browserHistory.push(routes.getAppDetailsLink(response._id));
    yield put(resetForm(formName));
  } else {
    yield put(appsModule.addAppFail(error));
    yield put(appsModule.closeAddAppModal());
    // yield put(stopSubmit(formName, { _error: 'Server Error' }));
    yield put(resetForm(formName));
    $('#appCreationErrorModal').foundation('open'); // eslint-disable-line no-undef
  }
}
export function* watchAddApp() {
  yield takeEvery(appsModule.addApp.getType(), addApp);
}

export function* updateApp({ payload: app }) {
  const { response, error } = yield call(Api.apps.updateApp, app);

  if (response) {
    yield put(appsModule.updateAppSuccess(response));
    browserHistory.push(routes.getAppDetailsLink(response._id));
    yield put(resetForm('defineNotLiveApp'));
  } else {
    yield put(appsModule.updateAppFail(error));
    yield put(stopSubmit('defineNotLiveApp', { _error: 'Server Error' }));
    yield put(resetForm('defineNotLiveApp'));
  }
}
export function* watchUpdateApp() {
  yield takeEvery(appsModule.updateApp.getType(), updateApp);
}

export function* fetchAppDetails({ payload: { appId } }) {
  const { response, error } = yield call(Api.apps.fetchAppDetails, appId);

  if (response) {
    yield put(appsModule.fetchAppDetailsSuccess(response));
  } else {
    yield put(appsModule.fetchAppDetailsFail(error));
  }
}
export function* watchFetchAppDetails() {
  yield takeEvery(appsModule.fetchAppDetails.getType(), fetchAppDetails);
}

export function* updateUnitStatus({ payload: { appId, unitId, active } }) {
  const { response, error } = yield call(Api.apps.updateUnitStatus, { appId, unitId, active });

  if (response) {
    yield put(appsModule.updateUnitStatusSuccess({ appId, unitId, active }));
  } else {
    yield put(appsModule.updateUnitStatusFail(error));
  }
}
export function* watchUpdateUnitStatus() {
  yield takeEvery(appsModule.updateUnitStatus.getType(), updateUnitStatus);
}

export function* addPlacement({ payload: { appId, unitId, placement } }) {
  const { response, error } = yield call(Api.apps.addPlacement, { appId, unitId, placement });

  if (response) {
    yield put(appsModule.addPlacementSuccess({ appId, unitId, placement: response }));
    yield put(resetForm('addPlacement'));
    yield put(appsModule.closeAddPlacement());
  } else {
    yield put(appsModule.addPlacementFail(error));
    yield put(stopSubmit('addPlacement', { _error: 'Server Error' }));
    yield put(resetForm('addPlacement'));
  }
}
export function* watchAddPlacement() {
  yield takeEvery(appsModule.addPlacement.getType(), addPlacement);
}

export function* closeAddPlacement() {
  yield put(resetForm('addPlacement'));
}
export function* watchCloseAddPlacement() {
  yield takeEvery(appsModule.closeAddPlacement.getType(), closeAddPlacement);
}

export function* updatePlacement({ payload: { appId, unitId, placementId, placement } }) {
  const { response, error } =
    yield call(Api.apps.updatePlacement, { appId, unitId, placementId, placement });

  if (response) {
    yield put(appsModule.updatePlacementSuccess({ appId, unitId, placementId, placement }));
    yield put(resetForm('addPlacement'));
    yield put(appsModule.closeAddPlacement());
  } else {
    yield put(stopSubmit('addPlacement', { _error: 'Server Error' }));
    yield put(appsModule.updatePlacementFail(error));
  }
}
export function* watchUpdatePlacement() {
  yield takeEvery(appsModule.updatePlacement.getType(), updatePlacement);
}

export function* deletePlacement({ payload: { appId, unitId, placementId } }) {
  const { response, error } =
    yield call(Api.apps.deletePlacement, { appId, unitId, placementId });

  if (response) {
    yield put(appsModule.deletePlacementSuccess({ appId, unitId, placementId }));
  } else {
    yield put(appsModule.deletePlacementFail(error));
  }
}
export function* watchDeletePlacement() {
  yield takeEvery(appsModule.deletePlacement.getType(), deletePlacement);
}

export function* updatePlacementStatus({ payload: { appId, unitId, placementId, active } }) {
  const { response, error } =
    yield call(Api.apps.updatePlacementStatus, { appId, unitId, placementId, active });

  if (response) {
    yield put(appsModule.updatePlacementStatusSuccess({ appId, unitId, placementId, active }));
  } else {
    yield put(appsModule.updatePlacementStatusFail(error));
  }
}
export function* watchUpdatePlacementStatus() {
  yield takeEvery(appsModule.updatePlacementStatus.getType(), updatePlacementStatus);
}

export function* updatePostback({ payload: { appId, postback, unitId } }) {
  const { response, error } =
    yield call(Api.apps.updatePostback, { appId, postback, unitId });

  if (response) {
    yield put(appsModule.updatePostbackSuccess({ appId, postback, unitId }));
    yield put(appsModule.closeUpdatePostback());
    yield put(resetForm('updatePostback'));
  } else {
    yield put(appsModule.updatePostbackFail(error));
  }
}
export function* watchUpdatePostback() {
  yield takeEvery(appsModule.updatePostback.getType(), updatePostback);
}

export function* updateSurveyPromotion({ payload: { appId, unitId, surveyPromotion } }) {
  const { response, error } =
    yield call(Api.apps.updateSurveyPromotion, { appId, unitId, surveyPromotion });

  if (response) {
    yield put(appsModule.updateSurveyPromotionSuccess({ appId, unitId, surveyPromotion }));
  } else {
    yield put(stopSubmit('updateSurveyPromotion', { _error: 'Server Error' }));
    yield put(appsModule.updateSurveyPromotionFail(error));
  }
}
export function* watchUpdateSurveyPromotion() {
  yield throttle(500, appsModule.updateSurveyPromotion.getType(), updateSurveyPromotion);
}

export function* createApiRequest({ payload: { appId, unitId, placementId } }) {
  const { response, error } =
    yield call(Api.apps.createApiRequest, { appId, unitId, placementId });

  if (response) {
    yield put(appsModule.createApiRequestSuccess({
      appId,
      unitId,
      placementId,
      placement: response,
    }));
  } else {
    yield put(appsModule.createApiRequestFail(error));
  }
}
export function* watchCreateApiRequest() {
  yield takeEvery(appsModule.createApiRequest.getType(), createApiRequest);
}

export default function* watchApps() {
  return yield all([
    fork(watchFetchApps),
    fork(watchFetchAppsNames),
    fork(watchParseAppFromUrl),
    fork(watchAddApp),
    fork(watchFetchAppDetails),
    fork(watchUpdateUnitStatus),
    fork(watchAddPlacement),
    fork(watchCloseAddPlacement),
    fork(watchUpdatePlacement),
    fork(watchDeletePlacement),
    fork(watchUpdatePlacementStatus),
    fork(watchUpdatePostback),
    fork(watchUpdateSurveyPromotion),
    fork(watchCreateApiRequest),
    fork(watchUpdateApp),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/apps.saga.js
 **/